export default "__VITE_ASSET__C__NvttJ__"